var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"p-3"},[_c('h2',[_vm._v("Nothing here...")]),_c('p',[_vm._v(" Only the void is located by this address. ")])])
}]

export { render, staticRenderFns }